import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { InternalRoutes } from '../../../enum/InternalRoutes';
import DOMPurify from 'dompurify';

const StripeSuccessfulPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    const packageName = decodeURIComponent(searchParams.get('packageName') ?? '');

    const navigateTo = () => {
        navigate(InternalRoutes.BRAND_DISCOVERY, { replace: true });
    };

    return (
        <div className="d-flex align-items-center justify-content-center h-100 mt-4 mt-md-0">
            <div className="text-center">
                <img width={90} src="/icons/approved-icon.svg" alt="Successful icon" />
                <h2>{t('general.stripe.payment_successful', { packageName: packageName })}</h2>
                <p
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            t('general.stripe.payment_successful_desc', { packageName: packageName })
                        ),
                    }}
                    className="text-muted"
                ></p>
                <Button onClick={navigateTo}>{t('general.stripe.payment_successful_btn')}</Button>
            </div>
        </div>
    );
};

export default StripeSuccessfulPage;
